export default __webpack_public_path__ + "static/media/icon-enroll-white.4cec84c1.svg";